<template>
  <div v-if="!_.isEmpty(dataSet)">
    <div class="part">
      <div class="breadcrumbs ellipsis">
        从 <span>{{dataSet.type === 1 ? '中国' : '美国'}}</span> 到
        <span>{{dataSet.type === 1 ? '美国' : '中国'}}</span> 进口
        <span>{{dataSet.type === 1 ? dataSet.cnCode : dataSet.usCode}}</span>
      </div>
      <section class="mini">
        <div class="caption">关税税率</div>
        <div class="cell">
          <Row :gutter="15">
            <Col span="6" class="card-rate">
              <div class="card-rate-wrap">
                <div class="card-rate-content clearfix">
                  <div class="name2">
                    <div class="rname">是否加征关税</div>
                  </div>
                  <div class="value">{{dataSet.levy === 0 ? '否' : '是'}}</div>
                </div>
              </div>
            </Col>
            <Col span="6" class="card-rate" v-if="dataSet.levy !== 0">
              <div class="card-rate-wrap">
                <div class="card-rate-content clearfix">
                  <div class="name2">
                    <div class="rname">加征关税税率</div>
                  </div>
                  <div class="value" v-html="$options.filters.rateValueConver(dataSet.levy)"></div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </section>
    </div>
  </div>
  <!--<div style="margin-top: 20px;line-height: 28px;color: #999;font-size:13px;" v-else>-->
     <!--<p style="color:#333;font-weight:bold;">使用说明</p>-->
     <!--<p>美国公布的征税信息是基于美国的商品编码规则发布的，它和中国商品编码存在一定的差异，例如（美方税号84013000 = 中方84013090）。</p>-->
     <!--<p>如果您不太清楚彼此之间的规则，O-TECH系统已经内置了转换逻辑，您可以直接输入中国的HSCODE查看相关结果。</p>-->
  <!--</div>-->
</template>

<script>
export default {
  name: 'ZMTariffQueryContent',
  props: ['dataSet']
}
</script>
<style scoped>
  .breadcrumbs{
    margin-top: 20px;
    margin-bottom: 10px;
    font-size: 13px;
  }
  .breadcrumbs span{
    color: #1f8afd;
  }
  .part{
    position: relative;
    margin-bottom: 12px;
  }
  .part:last-child{
    margin-bottom: 0;
  }
  .cell{
    padding: 0;
    /*font-size: 11px;*/
    font-size: 13px;
  }
  section{
    background-color: #fff;
    padding: 20px 0 25px;
  }
  section.mini{
    padding-bottom: 10px;
  }
  section:last-child{
    margin-bottom: 0;
  }
  .caption{
    /*font-size: 12px;*/
    font-size: 14px;
    color: #333;
    font-weight: bold;
    background: url("~@/assets/images/icons/show/guide.png") 0 4px no-repeat transparent;
    background-size: 4px 12px;
    padding-left: 13px;
    margin-bottom: 15px;
    position: relative;
  }
  .cell .title{
    color: #333;
    /*font-size: 12px;*/
    font-size: 14px;
  }
  .cell .value{
    color: #333;
  }
  .cell >>> .ivu-row{
    margin-bottom: 10px;
  }
  .cell >>> .ivu-row:last-child{
    margin-bottom: 0;
  }
  .cell >>> .ivu-col{
    margin-bottom: 15px;
  }
  .cell .value .unit{
    color: #666;
    /*font-size: 8px;*/
    font-size: 10px;
    padding-left: 1px;
  }
  .card-rate{
    margin-bottom: 15px;
  }
  .card-rate-wrap{
    position: relative;
    background-color: #fff;
    border: 1px solid #ECECEC;
    box-shadow: 3px 3px 5px 0 rgba(225,225,225,0.50);
    /*height: 66px;*/
    height: 78px;
    max-width: 230px;
  }
  .card-rate-content{
    color: #333;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 15px;
    right: 18px;
  }
  .card-rate-content .name,
  .card-rate-content .name2{
    float: left;
    /*font-size: 11px;*/
    font-size: 13px;
  }
  .card-rate-content .name,
  .card-rate-content .name2{
    position: absolute;
    top:50%;
    left:0;
    transform: translateY(-50%);
  }
  .card-rate-content .value{
    float: right;
    /*font-size: 12px;*/
    font-size: 14px;
    /*position: relative;*/
    /*top:-2px;*/
  }
  .card-rate-content .value >>> .unit{
    /*font-size: 9px;*/
    font-size: 11px;
    color: #151515;
  }
</style>



// WEBPACK FOOTER //
// src/components/zmTariffQuery/ListContent.vue